import styles from './index.less';
import { useEffect, useState } from 'react';
import NoData from '@/components/NoData';
import { detailWechatQuestionnaire, submitWechatRespondents, viewWechatRespondents } from '@/service/banner';
import { Helmet, useLocation, useModel } from '@umijs/max';
import { history } from '@umijs/max';
import { Cell, Checkbox, Input, Loading, Radio, Toast } from 'react-vant';
import BottomButton from '../components/BottomButton';
import { InfoO } from '@react-vant/icons';
import dayjs from 'dayjs';

interface WechatQuestionnaireDataType {
  communityId?: string;
  communityName?: string;
  content?: string;
  createBy?: string;
  createTime?: string;
  image?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  topFlag?: string;
  updateBy?: string;
  updateTime?: string;
  viewCount?: number;
  statusFormatName?: string;
  startTime?: string;
  endTime?: string;
  signupEndTime?: string;
  signupStartTime?: string;
  address?: string;
  activityAmount?: string;
  questions?: Array<any>;
}
const SatisfactionLevelDetail = () => {
  console.log(666, useLocation());
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');
  const { ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation
    }),
  );

  const formatStatus = (item: any) => {
    if (item.response === '1') {
      return '已提交';
    } else if (item.endFlag === '1' ) {
      return '已结束';
    } else {
      const startTime = dayjs(item.startTime);
      const endTime = dayjs(item.endTime);
      const currentTime = dayjs();
      const isAfterCurrentTime = currentTime.isAfter(endTime);
      const isBeforeCurrentTime = currentTime.isBefore(startTime);
      if (isBeforeCurrentTime) {
        return '未开始';
      }

      if (isAfterCurrentTime) {
        return '已结束';
      }

      if (!isAfterCurrentTime && !isBeforeCurrentTime) {
        return '进行中';
      }
    }
  };
  console.log(data)
  const [WechatQuestionnaireData, setWechatQuestionnaireData] = useState<WechatQuestionnaireDataType>({});
  const [Loading, setLoading] = useState<any>(false);
  const [QuestionsList, setQuestionList] = useState<any>([]);
  const [isHasAnswered, setisHasAnswered] = useState<any>(false);
  useEffect(() => {
    detailWechatQuestionnaire(data).then((res) => {
      console.log(res);
      if (res && res.code === 200 && res.data) {
        const status = formatStatus(res.data);
        if (status === '已结束' || status === '未开始' ) {
          setisHasAnswered(true)
        }
        const detailsListData = res.data.questions || []
        viewWechatRespondents({questionnaireId: data, ownerId: ownerInformation?.sequenceNbr,}).then((res) => {
          console.log(res)
          if (res && res.code === 200) {
            if (res.data) {
              setisHasAnswered(true)
            }
            const data = detailsListData.map((item: any, index: number )=> {
            
              return {
                ...item,
                disabled: res.data,
                answers: res.data && res.data.answers.length ? res.data.answers.find((answerItem: any) =>item.sequenceNbr === answerItem.questionId)?.answer || '': ''
              }
            })
            setQuestionList(data || [])
            // setAnswerList(res.data.answers)
          } else {
            const data = detailsListData.map((item: any, index: number )=> {
              return {
                ...item,
                disabled: false,
                answers: ''
              }
            })
            setQuestionList(data || [])
          }
        })
        setWechatQuestionnaireData(res.data);
        
      } else {
        setWechatQuestionnaireData({});
        setQuestionList([])
      }
    });
    
  }, [data]);



  // const formatTime = (time: any) => {
  //   return time ? dayjs(time).format('YYYY-MM-DD') : '-';
  // };
  const handleAnswerChange = (value: any, sequenceNbr: any) => {
    setQuestionList(QuestionsList.map((item: any) => 
      item.sequenceNbr === sequenceNbr ? { ...item, answers: value } : item
    ))
    console.log(99, QuestionsList)
  };
  const renderQuestionInput = (currentQuestion: any, index: number) => {
    switch (currentQuestion.questionType) {
      case 'radio':
        return (
          <Radio.Group  
            value={currentQuestion.answers} 
            onChange={(e) =>handleAnswerChange(e, currentQuestion.sequenceNbr)}
            direction="vertical"
            disabled= {currentQuestion.disabled}
          >
            {currentQuestion.options?.map((option: any, i: number) => (
              <Radio key={i} name={option.optionValue} className={styles['selectBox']}>
                {option.optionValue}
              </Radio>
            ))}
          </Radio.Group>
        );
        
      case 'checkbox':
        return (
          <Checkbox.Group
            value={currentQuestion.answers || []} 
            onChange={(e) =>handleAnswerChange(e, currentQuestion.sequenceNbr)}
            direction="vertical"
            disabled= {currentQuestion.disabled}
          >
            {currentQuestion.options?.map((option: any, i: number) => (
              <Checkbox key={i} name={option.sequenceNbr}  className={styles['selectBox']}>
                {option.optionValue}
              </Checkbox>
            ))}
          </Checkbox.Group>
        );
        
      case 'text':
        return (
        <Cell style={{ marginTop: 10 }}>
          <Input.TextArea  disabled= {currentQuestion.disabled} value={currentQuestion.answers || ''} onChange={(e) =>handleAnswerChange(e, currentQuestion.sequenceNbr)} placeholder="请输入" maxLength={200} showWordLimit />
        </Cell>
        );
        
      default:
        return null;
    }
  };

  const submit = () => {
    const isAnswer = QuestionsList.some((item: any) =>  item.answers === '' || item.answers === null || item.answers === undefined)
    console.log(isAnswer)
    if (isAnswer) {
      Toast('请完整的答题!')
      return
    }

    const answersList = QuestionsList?.map((item: any) => {
      return {
        questionId: item.sequenceNbr,
        questionnaireId: item.questionnaireId,
        answer: Array.isArray(item.answers) ? item.answers.join(',') : item.answers
      }
    })
    let params = {
      answers: answersList,
      openId:  localStorage.getItem('userOpenId'),
      ownerId: ownerInformation?.sequenceNbr,
      ownerName: ownerInformation?.nickName,
      phonenumber:ownerInformation?.phonenumber,
      questionnaireId: WechatQuestionnaireData.sequenceNbr
    }
    
    setLoading(true)
    submitWechatRespondents(params).then(res => {
      if (res && res.code === 200) {
        Toast.success('提交成功!')
        history.back()
      }
    }).finally(() => {
      setLoading(false)
    })
  
  }

  return (
    <div className={styles['satisfactionLevelDetail']}>
      <Helmet>
        <title>满意度详情</title>
      </Helmet>
      <div>
        {Object.entries(WechatQuestionnaireData).length ? (
          <>
            <div className={styles['newsDatailsBox']}>
              <div className={styles['headContainer']}>
                <div className={styles['title']}>{WechatQuestionnaireData.title}</div>
                <div className={styles['tip']}><InfoO  />为了保证调查的公平公正，请认真填写真实信息</div>
                <div className={styles['tip']}>满意度截止时间: {WechatQuestionnaireData.endTime}</div>
              </div>
              <div className={styles.quetionContaner}>
                  { QuestionsList && QuestionsList?.map((item: any, index: number) => (
                    <div  key={item.sequenceNbr}>
                      <div className={styles['name']}>
                       <div className={styles['nameText']}>第{item.questionSort + 1}题：{item.questionTitle}</div>
                       <div className={styles['nameType']}>{item.questionType === 'radio' ? '单选' : item.questionType === 'checkbox' ? '多选' : ''}</div>
                      </div>
                      <div className={styles['cellContainer']}>
                          <Cell.Group  card>
                            <div className={styles['cellGroup']} >{renderQuestionInput(item, index)}</div>
                          </Cell.Group>
                      </div>
                    </div>
                    )
                  )}
                  </div>
              {!isHasAnswered && (
                <div>
                  <BottomButton loading={Loading} text={'提交'} click={() => submit()}></BottomButton>
                </div>
              )}
            </div>
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default SatisfactionLevelDetail;
